import { Modal } from "@sicredi/react";
import { IModalAccountAgency } from "./model";
import { useNavigate } from "react-router-dom";
import { PAGE } from "#/constants";

export const SimulacaoOfertaIndisponivelModal: React.FC<
  IModalAccountAgency
> = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();

  const handleButton = async () => {
    setIsOpen(false);
    navigate(PAGE.ROOT);
  };

  return (
    <div>
      <Modal
        title="Esse produto não está disponível"
        onClose={() => handleButton()}
        show={isOpen}
        primaryButton={{
          children: "Entendi",
          onClick: () => handleButton(),
        }}
      >
        No momento, a contratação deste produto não está disponível neste canal.
        Tente novamente mais tarde ou fale com o seu Gerente.
      </Modal>
    </div>
  );
};
